/* eslint-disable react/require-default-props */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@material-ui/core';
import PopupCard from '../../common/PopupCard';
import SectionTabs from '../../common/SectionTabs';
import StudentStatusList from './StudentStatusList';
import CTAButton from '../../common/CTAButton';

const StudentDetailsPopup = ({
  open,
  onClose,
  selectedStudent,
  assignmentTitle
}) => {
  const [childTabIndex, setChildTabIndex] = useState(0);

  const handleChildTabIndexChange = (event, newValue) => {
    setChildTabIndex(newValue);
  };


  const incompleteStudents = [
    { name: 'Emma Rodriguez', status: 'notstarted' },
    { name: 'Michael Chen', status: 'inprogress' },
    { name: 'Sarah Johnson', status: 'notstarted' },
    { name: 'David Kim', status: 'inprogress' },
    { name: 'Lisa Anderson', status: 'notstarted' },
    { name: 'Robert Martinez', status: 'inprogress' },
    { name: 'Ashley Brown', status: 'notstarted' },
    { name: 'Kevin Taylor', status: 'inprogress' },
    { name: 'Jessica Davis', status: 'notstarted' },
    { name: 'Daniel Wilson', status: 'inprogress' },
    { name: 'Amanda Miller', status: 'notstarted' },
    { name: 'Christopher Moore', status: 'inprogress' },
    { name: 'Stephanie White', status: 'notstarted' },
    { name: 'Matthew Jackson', status: 'inprogress' },
    { name: 'Nicole Thomas', status: 'notstarted' }
  ];

  const completedStudents = [
    { name: 'Alex Thompson', status: 'completed' },
    { name: 'Maria Garcia', status: 'completed' },
    { name: 'James Wilson', status: 'completed' },
    { name: 'Jennifer Lee', status: 'completed' },
    { name: 'Brandon Clark', status: 'completed' },
    { name: 'Rachel Lewis', status: 'completed' },
    { name: 'Tyler Robinson', status: 'completed' },
    { name: 'Samantha Walker', status: 'completed' },
    { name: 'Justin Hall', status: 'completed' },
    { name: 'Megan Allen', status: 'completed' }
  ];

  return (
    <PopupCard
      open={open}
      onClose={onClose}
      width="640px"
      height="auto"
      maxWidth="640px"
      maxHeight="70vh"
      style={{
        minHeight: 400,
        width: '640px',
        boxSizing: 'border-box',
        padding: '32px'
      }}
    >
      {selectedStudent && (
        <Box>
          <Typography
            variant="h5"
            gutterBottom
            style={{
              fontWeight: 500,
              fontStyle: 'normal',
              fontSize: '24px',
              lineHeight: '32px',
              letterSpacing: '-0.02em',
              verticalAlign: 'middle',
              color: '#171717'
            }}
          >
            {assignmentTitle} completion status
          </Typography>

          <Box style={{ width: 252 }}>
            <SectionTabs
              value={childTabIndex}
              onChange={handleChildTabIndexChange}
              tab1Label={`Incomplete(${incompleteStudents.length})`}
              tab2Label={`Completed(${completedStudents.length})`}
              customTextStyle={{
                // fontFamily: 'Label Family',
                fontWeight: 500,
                fontStyle: 'normal',
                fontSize: '14px',
                lineHeight: '20px',
                letterSpacing: '0%',
                color: '#0D004D'
              }}
              indicatorColor="#512EAB"
            />
          </Box>

          <Box style={{ marginTop: 15 }}>
            {childTabIndex === 0 && (
              <StudentStatusList students={incompleteStudents} />
            )}

            {childTabIndex === 1 && (
              <StudentStatusList students={completedStudents} />
            )}
          </Box>

          <Box style={{
            marginTop: 24,
            display: 'flex',
            justifyContent: 'flex-start',
            flexShrink: 0,
            minWidth: 'fit-content'
          }}
          >
            <CTAButton
              label="Send reminder"
              secondary
              icon="mail"
              backgroundColor="#512EAB"
              onClick={() => {
                console.log('Send reminder clicked for assignment:', assignmentTitle);
              }}
              style={{ flexShrink: 0, minWidth: 'fit-content', height: '52px', borderRadius: '24px' }}
            />
          </Box>
        </Box>
      )}
    </PopupCard>
  );
};

StudentDetailsPopup.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  selectedStudent: PropTypes.shape({
    name: PropTypes.string.isRequired,
    topics: PropTypes.arrayOf(PropTypes.string).isRequired
  }),
  assignmentTitle: PropTypes.string
};

export default StudentDetailsPopup;
